import React from 'react'
import BasicElement from '@/components/commons/editor/BasicElement'

export const withBaseElement = ( WrappedComponent, props ) => {
  const { content } = props
  const { styles, attributes } = content
  const withBaseElement = () => {
    return (
      <BasicElement {...props}
        styles={styles}
        attributes={attributes}
        component={WrappedComponent}/>
    )
  }
  return withBaseElement
}


// WEBPACK FOOTER //
// ./src/hocs/withBasicElement.js